/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import {enquireScreen} from 'enquire-js';
import Banner3 from './Banner3';
import {Banner30DataSource} from './data.source';
import './less/antMotionStyle.less';
import Footer1 from "../Home/Footer1";
import Nav0 from "../Home/Nav0";
import {Footer10DataSource,Nav00DataSource} from "../Home/data.source";
import BreadcrumbCon from "../components/BreadcrumbCon";
import CoreBusiness from './coreBusiness';

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const {location} = window;

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            show: !location.port, // 如果不是 dva 2.0 请删除
        };
    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({isMobile: !!b});
        });
        // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
        /* 如果不是 dva 2.0 请删除 start */
        if (location.port) {
            // 样式 build 时间在 200-300ms 之间;
            setTimeout(() => {
                this.setState({
                    show: true,
                });
            }, 500);
        }
        /* 如果不是 dva 2.0 请删除 end */
    }

    render() {
        const children = [
            <Nav0
                id="Nav0_0"
                key="Nav0_0"
                dataSource={Nav00DataSource}
                isMobile={this.state.isMobile}
            />,
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"} style={{height: '5vh',}}>
                <BreadcrumbCon pageName={"产品及服务"} pagePath={"/productsAndServices"}/>
            </div>,
            <div className={"container"} style={{height: '100vh',marginTop:"40px",}}>
                <CoreBusiness
                />
            </div>,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
        ];
        return (
            <div
                className="templates-wrapper"
                ref={(d) => {
                    this.dom = d;
                }}
            >
                {/* 如果不是 dva 2.0 替换成 {children} start */}
                {this.state.show && children}
                {/* 如果不是 dva 2.0 替换成 {children} end */}
            </div>
        );
    }
}
